var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModalEditar", {
        attrs: {
          titulo: "Editar Mensaje",
          form: Object.values(_vm.pasos).find(function(x) {
            return x.step === _vm.pasoActivoIndex
          }).formState,
          pasos: _vm.pasos,
          pasoActivoIndex: _vm.pasoActivoIndex,
          entidad: "Mensaje",
          inactivable: _vm.modificable,
          nombreEntidad: _vm.pasos.informacionGeneral.formState.entity
            ? _vm.pasos.informacionGeneral.formState.entity.nombre
            : ""
        },
        on: {
          cerrar: _vm.handleCerrar,
          guardar: _vm.handleGuardar,
          inactivo: _vm.handleInactivo
        }
      }),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c(
        "ContenidoModal",
        [
          _c("MensajeForm", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.pasoActivoIndex === _vm.pasos.informacionGeneral.step,
                expression: "pasoActivoIndex === pasos.informacionGeneral.step"
              }
            ],
            attrs: {
              mensajeSeleccionado: _vm.mensajeSeleccionado,
              esEditar: true
            },
            on: { change: _vm.handleFormChange }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }